import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import IconButton from '@mui/material/IconButton';

import { ContactItemDto } from '@/api/generated';
import { themeColors } from '@/config/theme/themeColors.ts';
import { ContactsTableRowCommon } from '@/views/contacts/components/table/components/ContactsTableRowCommon.comp.tsx';

type Props = {
  onCustomAction?: (row: ContactItemDto) => void;
  row: ContactItemDto;
};

export const ProcessCreateAddContactTableRow = ({ onCustomAction, row }: Props) => {
  const handleSelectCustomer = () => {
    onCustomAction?.(row);
  };

  return (
    <ContactsTableRowCommon
      actions={
        <IconButton onClick={handleSelectCustomer}>
          <CheckCircleOutlinedIcon htmlColor={themeColors.green} />
        </IconButton>
      }
      onRowClick={handleSelectCustomer}
      row={row}
    />
  );
};
